import {Entity} from '@s-ui/domain'

export class ParsedUserAlertEntity extends Entity {
  /**
   * @param {Boolean} activeEmail
   * @param {Boolean} activePush
   * @param {Object} filters
   * @param {Boolean} activeRealtimeEmail
   * @param {Boolean} activeRealtimePush
   */
}
